import { mergeProps } from '@base-ui-components/react/merge-props'
import { useRender } from '@base-ui-components/react/use-render'
import { cn } from '../../utils/cn'
import { useFieldContext } from './field-context'

export function FieldControl({ render = <div />, ...props }: FieldControl.Props) {
  const { orientation } = useFieldContext()
  const element = useRender({
    render,
    props: mergeProps(
      {
        className: cn(
          orientation === 'horizontal' &&
            'group-[:has([data-slot=field-description])]/field-root:row-span-2'
        ),
        'data-slot': 'field-control',
      },
      props
    ),
  })
  return element
}

export namespace FieldControl {
  export interface Props extends useRender.ComponentProps<'div'> {}
}
